var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',_vm._l((_vm.cols),function(c){return _c('td',{key:c},[_vm._v(" "+_vm._s(c)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }